import PropertyFormContainer from 'components/Common/Panel/PropertyForm';
import React from 'react';

const CreateProperty = () => {
    return <PropertyFormContainer />;
};

export default CreateProperty;
